import { z } from 'zod';

import { DEFAULT_LOAD_MORE, DEFAULT_PAGE_NUMBER } from '../../constants';

export const defaultPagingSchema = z.object({
	pageNumber: z.number().optional().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().optional().prefault(DEFAULT_LOAD_MORE),
});
